import {format} from 'date-fns'
import {concat, from, of} from 'rxjs'
import {
  catchError,
  filter,
  ignoreElements,
  mergeMap,
  switchMap,
  tap,
} from 'rxjs/operators'
import {Epic, StateObservable} from 'redux-observable'

import {AppActions, RootState} from 'app/rootReducer'
import Toast from 'components/Basic/Toast'
import {translations} from 'definitions'
import {HTTP_STATUS_CODE} from 'definitions/constant'
import {PBFFService} from 'services/api'
import {
  downloadAnalyticsLogs,
  downloadAnalyticsLogsFailure,
  downloadAnalyticsLogsSuccess,
} from './actions'
import {DEFAULT_DATE_WITH_TIME_FORMAT} from 'definitions/constant'

const analyticsLogsDownloadEpic: Epic<
  AppActions,
  AppActions,
  StateObservable<RootState>
> = action$ =>
  action$.pipe(
    filter(downloadAnalyticsLogs.match),
    switchMap(({payload}) => {
      const requestBody = {
        userEmail: payload?.userEmail,
        dateTime: format(new Date(), DEFAULT_DATE_WITH_TIME_FORMAT),
      }
      return from(PBFFService.downloadAnalyticsLogs(requestBody)).pipe(
        mergeMap(resp => {
          const {data, status} = resp
          const {fileUrl = ''} = data?.response || {}
          if (status === HTTP_STATUS_CODE.NO_CONTENT) {
            Toast({message: translations.NO_RESULTS_AVAILABLE, type: 'info'})
          }
          return [downloadAnalyticsLogsSuccess(fileUrl)]
        }),
        catchError(() => concat(of(downloadAnalyticsLogsFailure()))),
      )
    }),
  )

const analyticsLogsDownloadFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(downloadAnalyticsLogsFailure.match),
    tap(() => Toast({message: translations.UNKNOWN_ERROR, type: 'error'})),
    ignoreElements(),
  )

export const analyticsLogsDownloadEpics = [
  analyticsLogsDownloadEpic,
  analyticsLogsDownloadFailureEpic,
]
